import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import EventList from "../pages/events/page";
import EventDetail from "../pages/events/detail/page";
import FaqPage from "../pages/faq/page";
import AboutPage from "../pages/about/page";
import SiteLayout from "@/components/feature/SiteLayout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "events",
        element: <EventList />,
      },
      {
        path: "events/:slug",
        element: <EventDetail />,
      },
      {
        path: "faq",
        element: <FaqPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;